/**
 * Size selector - syncs with product form and updates price
 * - Updates hidden variant ID input when size changes
 * - Updates displayed price
 * - Disables sold-out options
 */
(function () {
  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initSizeSelectors() {
    document.querySelectorAll('[data-size-selector]').forEach(function (wrapper) {
      var productId = wrapper.dataset.productId;
      var formId = wrapper.dataset.formId;
      var select = wrapper.querySelector('[data-size-select]');
      var variantsScript = wrapper.querySelector('[data-variants-json="' + productId + '"]');

      if (!select || !formId || !variantsScript) return;

      var form = document.getElementById(formId);
      if (!form) return;

      var variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;

      var variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        return;
      }

      var card = wrapper.closest('.card-wrapper, .product-card-wrapper, .card, .card__content');
      if (!card) card = wrapper.closest('.card-information') || wrapper.parentElement;

      var priceContainer = card ? card.querySelector('.price, .card-information .price, [class*="price"]') : null;

      function getVariantById(id) {
        return variants.find(function (v) {
          return String(v.id) === String(id);
        });
      }

      function updatePrice(variant) {
        if (!priceContainer || !variant) return;
        var formattedPrice = variant.price_formatted || formatMoney(variant.price);
        var formattedCompare = variant.compare_at_price_formatted || formatMoney(variant.compare_at_price);
        var onSale = variant.compare_at_price > 0 && variant.compare_at_price > variant.price;

        var priceItems = priceContainer.querySelectorAll('.price-item');
        if (priceItems.length >= 1) {
          priceItems[0].textContent = formattedPrice;
        }
        if (onSale && priceItems.length >= 2) {
          priceItems[1].textContent = formattedCompare;
        }
        var saleWrapper = priceContainer.querySelector('.price__sale');
        if (saleWrapper) {
          saleWrapper.style.display = onSale ? '' : 'none';
        }
        var regularWrapper = priceContainer.querySelector('.price__regular');
        if (regularWrapper) {
          regularWrapper.style.display = onSale ? 'none' : '';
        }
        priceContainer.classList.toggle('price--on-sale', onSale);
      }

      function setVariant(variantId) {
        var variant = getVariantById(variantId);
        variantInput.value = variantId;
        variantInput.disabled = variant && !variant.available;
        updatePrice(variant);
        var btn = form.querySelector('[type="submit"], button[name="add"]');
        if (btn) {
          btn.disabled = variant && !variant.available;
          var span = btn.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
          if (span) {
            span.textContent = variant && variant.available
              ? (btn.dataset.addText || 'ADD TO CART')
              : (btn.dataset.soldOutText || 'Sold out');
          }
        }
      }

      select.addEventListener('change', function () {
        var variantId = this.value;
        if (variantId) setVariant(variantId);
      });

      setVariant(select.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeSelectors);
  } else {
    initSizeSelectors();
  }

  document.addEventListener('shopify:section:load', initSizeSelectors);
})();
